import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where, Timestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function MatchesCard() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadMatches() {
      try {
        const now = new Date();
        const last7days = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

        // 🔥 Filtra apenas matches criados nos últimos 7 dias
        const qMatches = query(
          collection(db, "matches"),
          where("createdAt", ">=", Timestamp.fromDate(last7days))
        );

        const snap = await getDocs(qMatches);

        setCount(snap.size);
      } catch (error) {
        console.error("Erro ao buscar matches da semana:", error);
      } finally {
        setLoading(false);
      }
    }

    loadMatches();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Matchs sugeridos na semana</p>

      <p className="metric-value">
        {loading || count === null ? "..." : count.toLocaleString("pt-BR")}
      </p>

      <span className="metric-tag">Sugestões enviadas</span>
    </div>
  );
}
